
import { defineComponent, onMounted } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { getCurrentUser } from "@/utils/index";
import { companyPolicyAgree, getCompanyAgreementStatus } from "@/api/companypolicy";
import {
  isPolicyFullyAgreed,
  isSessionPolicyAgreed,
  markSessionPolicyAgreed,
  resolvePostPolicyRedirect
} from "@/utils/policyAgreement";

export default defineComponent({
  name: "companypolicymain",
  data() {
    return {
      currentUsid: "",
      policyPdfUrl: `${process.env.BASE_URL}policy/2023_627763ed-aa68-4a42-b366-b42bbb5aef74.pdf#toolbar=0&navpanes=0`,
      reviewMode: false,
      statusLoading: true,
      statusError: false,
      termsChecked: false,
      submitting: false
    };
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Company Policy");
    });
  },
  methods: {
    async loadAgreementStatus() {
      this.statusLoading = true;
      this.statusError = false;
      try {
        const response = await getCompanyAgreementStatus();
        const status = response && response.data;
        this.reviewMode = isSessionPolicyAgreed() || isPolicyFullyAgreed(status);
        if (this.reviewMode) {
          markSessionPolicyAgreed();
        }
      } catch {
        if (isSessionPolicyAgreed()) {
          this.reviewMode = true;
        } else {
          this.reviewMode = false;
          this.statusError = true;
        }
      } finally {
        this.statusLoading = false;
      }
    },
    goBack() {
      const pt = localStorage.getItem("pt") || "";
      const destination = resolvePostPolicyRedirect(this.$route.query.redirect, pt);
      this.$router.push(destination);
    },
    logout() {
      this.$router.push("/logout");
    },
    async agreeToCompanyPolicy() {
      if (!this.termsChecked || this.submitting) {
        return;
      }

      this.submitting = true;
      try {
        const response = await companyPolicyAgree();
        if (response == null) {
          throw new Error("Unable to record agreement.");
        }
        this.goBack();
      } catch {
        Swal.fire({
          title: "",
          text: "Unable to save your agreement. Please try again.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary"
        });
      } finally {
        this.submitting = false;
      }
    }
  },
  mounted() {
    const user = getCurrentUser();
    this.currentUsid = (user && user.usid) || "";
    this.loadAgreementStatus();
  }
});
